export { type NumberRange, getOverlapLength } from '@iotv/iotv-v3-types'
